import React from 'react';
import { BRAND, isMarketGB } from '../../constants/main';
import { SummaryDiscountDetailsAC } from './AC/SummaryDiscountDetails.AC';
import { SummaryDiscountDetailsOV } from './OV/SummaryDiscountDetails.OV';
import { SummaryDiscountDetailsAP } from './AP/SummaryDiscountDetails.AP';
import { SummaryDiscountDetailsDS } from './DS/SummaryDiscountDetails.DS';
import { SummaryDiscountDetailsOV as SummaryPriceDetailsOV_GB } from './OV/GB/SummaryDiscountDetails.OV';
import { SummaryDiscountDetailsStyled } from './SummaryDiscountDetailsStyled';
import { SC } from '../../styles/theme';

export type SummaryDiscountDetailsProps = SC & {};

const SummaryDiscountDetails = (props: SummaryDiscountDetailsProps) => {
    if (BRAND === 'AC') return <SummaryDiscountDetailsAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <SummaryPriceDetailsOV_GB {...props} /> : <SummaryDiscountDetailsOV {...props} />;
    if (BRAND === 'AP') return <SummaryDiscountDetailsAP {...props} />;
    if (BRAND === 'DS') return <SummaryDiscountDetailsDS {...props} />;
    return <SummaryDiscountDetailsStyled {...props} />;
};

export default SummaryDiscountDetails;
